import { Layout, Menu, Input, Button, Checkbox } from 'element-react';
import { useTranslation } from 'react-i18next';
import filterSearchStore from '../store/filter-search';
import { useEffect, useState } from 'react';

const LeftMenuFilter = (props) => {
    const { t } = useTranslation();
    const { filterInfo, setFilterInfo, selectedCategories, setSelectedCategories } = filterSearchStore();

    const [minPrice, setMinPrice] = useState();
    const [maxPrice, setMaxPrice] = useState();
    const [currentTab, setCurrentTab] = useState('products');
    
    // Estados para manejar los checkboxes de ubicación 
    const [availableStates, setAvailableStates] = useState([]);
    const [selectedStates, setSelectedStates] = useState([]);

    const [localFilterOptions, setLocalFilterOptions] = useState(
        {
            customAllowed: false,
            warranty: false,
            minBuy: false
        }
    );

    const onOpen = (menu) => {
        console.log('open :: ' + menu);
    }
    const onSelect = (index) => {
        console.log('selected :: ' + index);
    }

    // Listener para cambio de Tab
    useEffect(() => {
        const handleTabListener = (event) => {
            console.log("LeftMenu: Tab cambió a", event.detail);
            setCurrentTab(event.detail);
            
            // Limpiamos la selección visual al cambiar de tab para evitar confusiones
            setSelectedStates([]);
            // limpiamos la lista disponible momentáneamente hasta que llegue el evento de update
            setAvailableStates([]);
            if (event.detail !== currentTab) {
               setSelectedCategories([]); 
            }
        };

        window.addEventListener('searchTabChanged', handleTabListener);
        return () => {
            window.removeEventListener('searchTabChanged', handleTabListener);
        };
    }, []);

    // Listener para recibir los estados desde SearchResultNG
    useEffect(() => {
        const handleUpdateStates = (event) => {
            console.log("LeftMenu: Recibidos estados de empresas", event.detail);
            if (event.detail && Array.isArray(event.detail)) {
                setAvailableStates(event.detail);
            }
        };

        window.addEventListener('CMD_UPDATE_STATES', handleUpdateStates);
        return () => {
            window.removeEventListener('CMD_UPDATE_STATES', handleUpdateStates);
        };
    }, []);

    const isCompaniesTab = currentTab === 'companies';

    const handlePriceFilter = () => {
        setFilterInfo(filterInfo.pageSize, minPrice === '' ? 0 : minPrice, maxPrice === '' ? 10000000 : maxPrice,
            filterInfo.customAllowed, filterInfo.warranty, filterInfo.minBuy);
    }

    useEffect(() => {
        setMinPrice(filterInfo.minPrice === 0 ? '' : filterInfo.minPrice);
        setMaxPrice(filterInfo.maxPrice === 10000000 ? '' : filterInfo.maxPrice);
        setLocalFilterOptions(
            {
                customAllowed: filterInfo.customAllowed,
                warranty: filterInfo.warranty,
                minBuy: filterInfo.minBuy
            }
        );
    }, [])

    const handleFilterCustomAllowedChange = (v) => {
        setLocalFilterOptions({ ...localFilterOptions, customAllowed: v })
        setFilterInfo(filterInfo.pageSize, filterInfo.minPrice, filterInfo.maxPrice, v, filterInfo.warranty, filterInfo.minBuy);
    }

    const handleFilterWarrantyChange = (v) => {
        setLocalFilterOptions({ ...localFilterOptions, warranty: v })
        setFilterInfo(filterInfo.pageSize, filterInfo.minPrice, filterInfo.maxPrice, filterInfo.customAllowed, v, filterInfo.minBuy);
    }
    const handleFilterMinBuyChange = (v) => {
        setLocalFilterOptions({ ...localFilterOptions, minBuy: v })
        setFilterInfo(filterInfo.pageSize, filterInfo.minPrice, filterInfo.maxPrice, filterInfo.customAllowed, filterInfo.warranty, v);
    }

    // Manejador del cambio de checkbox de estado
    const handleStateChange = (stateName, isChecked) => {
        let newSelection = [];
        
        if (isChecked) {
            newSelection = [...selectedStates, stateName];
        } else {
            newSelection = selectedStates.filter(s => s !== stateName);
        }
        
        setSelectedStates(newSelection);

        console.log("LeftMenu: Enviando filtros de estado:", newSelection);
        const event = new CustomEvent('CMD_FILTER_BY_STATE', { detail: newSelection });
        window.dispatchEvent(event);
    }

    return (
        <Layout.Row className="tac filtered-left-menu">
            <Layout.Col span={24}>
                <div className="sidenav" style={{ display: 'flex' }}>
                    <Menu defaultActive="1" className="el-menu-vertical-demo" onOpen={onOpen.bind(this)} onSelect={(index) => { onSelect(index) }}>
                        <div>
                            &nbsp;
                        </div>
                        <div className="left-menu-filter">
                            <Layout.Row type="flex" span="24">
                                <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                    <h3>{t('search.left-filter.title')}</h3>
                                </Layout.Col>
                            </Layout.Row>

                            {/* --- 1. SECCIÓN DE UBICACIÓN (Visible en AMBOS TABS) --- */}
                            {/* Solo la mostramos si hay estados disponibles O si estamos en companies (para mostrar "No results") */}
                            {(availableStates.length > 0 || isCompaniesTab) && (
                                <>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <h4>Filter by Location</h4>
                                        </Layout.Col>
                                    </Layout.Row>
                                    {availableStates.length > 0 ? availableStates.map((state, i) => (
                                        <Layout.Row key={i} type="flex" span="24">
                                            <Layout.Col span="" className="bottom-spacer-10" offset="1" xs="24" sm="22" md="22" lg="22">
                                                <Checkbox
                                                    checked={selectedStates.includes(state)}
                                                    onChange={(v) => handleStateChange(state, v)}
                                                >
                                                    {state}
                                                </Checkbox>
                                            </Layout.Col>
                                        </Layout.Row>
                                    )) : (
                                        <Layout.Row type="flex" span="24">
                                            <Layout.Col offset="1" xs="24" sm="22" md="22" lg="22">
                                                <span style={{color:'#999', fontSize:'12px'}}>No locations found</span>
                                            </Layout.Col>
                                        </Layout.Row>
                                    )}
                                    <hr style={{margin: '15px 15px', border: '0', borderTop: '1px solid #eee'}}/>
                                </>
                            )}

                            {/* --- 2. CATEGORÍAS (Visible Siempre que haya datos) --- */}
                            {filterInfo.categories?.length > 0 && (
                                <>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <h4>Filter Category</h4>
                                        </Layout.Col>
                                    </Layout.Row>
                                    {filterInfo.categories.map((category, index) => {
                                        return (
                                            <Layout.Row key={index} type="flex" span="24">
                                                <Layout.Col span="" className="bottom-spacer-10" offset="1" xs="24" sm="22" md="22" lg="22">
                                                    <Checkbox
                                                        id={category.id}
                                                        checked={selectedCategories.includes(category)}
                                                        onChange={(v) => {
                                                            if (v) setSelectedCategories([...selectedCategories, category]);
                                                            else setSelectedCategories(selectedCategories.filter((c) => c !== category));
                                                        }}
                                                    >
                                                        {category}
                                                    </Checkbox>
                                                </Layout.Col>
                                            </Layout.Row>
                                        )
                                    })}
                                    {!isCompaniesTab && <hr style={{margin: '15px 15px', border: '0', borderTop: '1px solid #eee'}}/>}
                                </>
                            )}

                            {/* --- 3. OTROS (Precio, Garantía) - SOLO en Productos --- */}                                
                            {!isCompaniesTab && (
                                <>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <h4>{t('search.left-filter.sub-title1')}</h4>
                                        </Layout.Col>
                                    </Layout.Row>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" className="bottom-spacer-10" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <Checkbox
                                                checked={localFilterOptions.customAllowed}
                                                onChange={(v) => { handleFilterCustomAllowedChange(v) }}
                                            >
                                                {t('search.left-filter.custom')}
                                            </Checkbox>
                                        </Layout.Col>
                                    </Layout.Row>
                                    
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" className="bottom-spacer-10" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <Checkbox
                                                checked={localFilterOptions.warranty}
                                                onChange={(v) => { handleFilterWarrantyChange(v) }}
                                            >
                                                {t('search.left-filter.warranty')}
                                            </Checkbox>
                                        </Layout.Col>
                                    </Layout.Row>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <Checkbox
                                                checked={localFilterOptions.minBuy}
                                                onChange={(v) => { handleFilterMinBuyChange(v) }}
                                            >
                                                {t('search.left-filter.min-buy')}
                                            </Checkbox>
                                        </Layout.Col>
                                    </Layout.Row>
                                    <Layout.Row type="flex" span="24">
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="22">
                                            <h4>{t('search.left-filter.sub-title2')}</h4>
                                        </Layout.Col>
                                    </Layout.Row>
                                    <Layout.Row type="flex" span="24" className='flex-wrapMenu'>
                                        <Layout.Col span="" offset="1" xs="24" sm="22" md="22" lg="7">
                                            <Input value={minPrice} onChange={v => { setMinPrice(v) }} style={{ fontSize: '10px' }} />
                                        </Layout.Col>
                                        <Layout.Col span=""
                                            style={{ top: '8px', position: 'relative', left: '5px' }}
                                            xs="1" sm="1" md="1" lg="1">
                                            -
                                        </Layout.Col>
                                        <Layout.Col span="1" offset="1" xs="24" sm="22" md="22" lg="7">
                                            <Input value={maxPrice} onChange={v => { setMaxPrice(v) }} style={{ fontSize: '10px' }} />
                                        </Layout.Col>
                                        <Layout.Col span="1" xs="1" sm="1" md="1" lg="1">

                                        </Layout.Col>
                                        <Layout.Col tag="form-button-inverse" className="left-filter" lg="6">
                                            <Button onClick={handlePriceFilter} style={{ width: '50px', height: '30px', marginTop: '10px', padding: '0px' }} type="primary">Ok</Button>
                                        </Layout.Col>
                                    </Layout.Row>
                                </>
                            )}
                        </div>
                    </Menu>
                </div>
            </Layout.Col>
        </Layout.Row>
    )
}

export default LeftMenuFilter;